import { PaymentNotFound } from '@/modules/checkout/components/PaymentNotFound'

export const Error404 = () => {
  return <PaymentNotFound />
}
